// extracted by mini-css-extract-plugin
module.exports = {"root":"Row_root__3wTqI"};